import AuthRequest from '@/users/requests/auth-request'
import AuthResponse from '@/users/responses/auth-response'
import authService from '@/users/services/auth-service'
import { Component, Vue, Ref } from 'vue-property-decorator'

@Component
export default class LoginForm extends Vue {
  @Ref()
  private validator!: ValidationObserver

  private loggingIn = false
  private request = new AuthRequest()
  private response: AuthResponse | null = new AuthResponse()

  private showResetForm = false
  private email = ''
  private rememberMe = false
  private loading = false

  public async login() {
    if (await this.validator.validate()) {
      this.loggingIn = true
      this.response = await authService.loginAsync(this.request)
      this.loggingIn = false
    }
  }

  public async sendResetLink() {
    if (await this.validator.validate()) {
      this.loading = true
      await authService.sendPasswordResetLinkAsync(this.email)
      this.loading = false
      this.showResetForm = false
    }
  }
}
